import { tablePagination } from '$components/Table/styles.css'
import { APIWithPagerMeta } from '$services/api'
import { Pager } from '@genie-fintech/ui/components'
import { trueOrUndefined } from '@genie-fintech/ui/functions'
import { usePager } from '@genie-fintech/ui/hooks'
import { themeVars } from '@genie-fintech/ui/style/theme'
import { title } from '@genie-fintech/ui/style/typography'

const { colors } = themeVars

interface IProps {
  pagerProps: ReturnType<typeof usePager>
  meta?: APIWithPagerMeta['meta']
  isStickyBottom?: boolean
}

const Pagination = ({ pagerProps, meta, isStickyBottom }: IProps) => {
  return (
    <footer
      className={tablePagination}
      data-sticky-bottom={trueOrUndefined(isStickyBottom)}
    >
      {meta && (
        <p className={title.five} style={{ color: colors.neutral[60] }}>
          {meta.from} - {meta.to} of {meta.total} Results
        </p>
      )}

      <Pager align="right" {...pagerProps} />
    </footer>
  )
}

export default Pagination
